import {minToTimeString} from '../helpers'
import {t} from '@eitje/bridge'
import _ from 'lodash'

export const TIME_FORMAT = 'HH:mm'
export const HOURS_PER_DAY = 24
export const MINUTES_PER_HOUR = 60

export function formatMinutes(minutes = 0, format) {
	switch (format) {
		case 'time': // Examples: "00:15", "01:15"
			return formatTimeString(minutes)
		case 'timeWithLabel': // Examples: "15 min", "1:15 hour"
			return formatTimeWithLabel(minutes)
		case 'paddedTimeWithLabel': // Examples: "00:15 min", "01:15 hour"
			return formatTimeWithLabel(minutes, {padded: true})
		case 'shortTime': // Examples: "8:00", "1:15"
			return formatShortTime(minutes)
	}
}

function formatTimeString(minutes) {
	return minToTimeString(minutes)
}

function formatTimeWithLabel(minutes, options = {}) {
	const {padded} = options

	if (minutes < MINUTES_PER_HOUR) return `${minutes} ${t('common.short_minute_suffix')}`
	const totalHours = Math.floor(minutes / MINUTES_PER_HOUR)
	const remainingMinutes = minutes % MINUTES_PER_HOUR
	const hourString = _.padStart(totalHours, padded ? 2 : 1, '0')
	const minuteString = _.padStart(remainingMinutes, 2, '0')

	return `${hourString}:${minuteString} ${t('common.short_hour_suffix')}`
}

function formatShortTime(minutes) {
	const roundedMinutes = Math.round(minutes)

	if (roundedMinutes < MINUTES_PER_HOUR) return `0:${_.padStart(roundedMinutes, 2, '0')}`
	const totalHours = Math.floor(roundedMinutes / MINUTES_PER_HOUR)
	const remainingMinutes = roundedMinutes % MINUTES_PER_HOUR
	const hourString = _.padStart(totalHours, 1, '0')

	const minuteString = _.padStart(remainingMinutes, 2, '0')
	return `${hourString}:${minuteString}`
}
